import { Action } from "redux";

export const CANCEL_SUBSCRIPTION_FOR_USER_SUCCESS =
  "SUBSCRIPTION:CANCEL_SUBSCRIPTION_FOR_USER_SUCCESS";

export interface CancelSubscriptionForUserSuccess extends Action {
  type: typeof CANCEL_SUBSCRIPTION_FOR_USER_SUCCESS;
  organizationKeyName: string;
  userId: number;
  subscriptionId: string;
}

export const cancelSubscriptionForUserSuccess = (
  organizationKeyName: string,
  userId: number,
  subscriptionId: string
): CancelSubscriptionForUserSuccess => ({
  type: CANCEL_SUBSCRIPTION_FOR_USER_SUCCESS,
  organizationKeyName,
  userId,
  subscriptionId,
});
